﻿body {
  *::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  /* Track */
  *::-webkit-scrollbar-track {
    background: var(--second-50);
  }

  /* Handle */
  *::-webkit-scrollbar-thumb {
    background: var(--main-10);
  }

  /* Handle on hover */
  *::-webkit-scrollbar-thumb:hover {
    background: var(--main-10);
  }
}